import React from 'react'
import CustTable from '../../Common/CustTable'
import { t } from 'i18next'
import { Button, Popover, Statistic, Tag } from 'antd'
import { FormOutlined, CheckOutlined, CloseOutlined } from '@ant-design/icons'
import { Link } from 'react-router-dom'
import dayjs from 'dayjs'
import { Color } from '../../Common/Color'
import EventTag from '../TagsPage/EventTag'
import EventInChargeSelect from './EventInChargeSelect'
import AppointmentTypeTag from '../TagsPage/AppointmentTypeTag'
import { ActionButton } from '../../Common/Common'

const displayTags = (event) => {
  return event.tags.map((tag) => (<div key={`${event.id}-${tag.id}`}><EventTag tag={tag} type='tag' /></div>))
}

export default function EventListXL ({ events, showEvent, resolveEvent, updateEvent }) {
  const { Timer } = Statistic

  const displayCreationDateInformations = (date) => {
    return (
      <Popover content={date.format('DD/MM/YYYY HH:mm')} title={t('Admin.EventList.table.created_at')} placement='right'>
        <div>
          <Timer type='countup' value={date} format='D[j] H[h]mm[m]' style={{ '--ant-statistic-content-font-size': '17px' }} />
        </div>
      </Popover>
    )
  }

  const columns = (showEvent, resolveEvent) => [
    {
      width: 20,
      title: t('Admin.EventList.table.created_since'),
      dataIndex: 'created_at',
      key: 'created_at',
      render: (value) => displayCreationDateInformations(dayjs(value))
    },
    {
      width: 30,
      title: t('Admin.EventList.table.box'),
      dataIndex: 'box',
      key: 'box',
      sorter: (a, b) => a.box - b.box,
      render: (_, event) => (event.box && <Link to={`/admin/boxes/${event.box.id}/calendar`}>{event.box.name}</Link>)
    },
    {
      width: 20,
      title: t('Admin.EventList.table.appointment_type'),
      dataIndex: 'appointment_type',
      key: 'appointment_type',
      render: (_, o) => o.appointment ? <AppointmentTypeTag appointment={o.appointment} /> : <Tag color='grey' variant='solid'>{t('Admin.Appointment.type.none')}</Tag>
    },
    {
      width: 15,
      title: t('Admin.EventList.table.resolved'),
      dataIndex: 'resolved',
      key: 'resolved',
      render: (resolved) => resolved ? <CheckOutlined style={{ color: Color.green }} /> : <CloseOutlined style={{ color: Color.red }} />
    },
    {
      width: 20,
      title: t('Admin.EventList.table.inCharge'),
      dataIndex: 'in_charge',
      key: 'in_charge',
      render: (_, o) => <EventInChargeSelect event={o} updateEventData={updateEvent} reduced={true} />
    },
    {
      width: 50,
      title: t('Admin.EventList.table.tag'),
      dataIndex: 'tag',
      key: 'tag',
      render: (_, o) => displayTags(o)
    },
    {
      width: 100,
      title: t('Admin.EventList.table.title'),
      dataIndex: 'title',
      key: 'title',
      sorter: (a, b) => a.title.localeCompare(b.title)
    },
    {
      width: 25,
      title: t('Admin.EventList.table.comment_count'),
      dataIndex: 'comments_count',
      key: 'comments_count'
    },
    {
      width: 20,
      key: 'action',
      render: (_, o) => (<div style={{ display: 'flex', justifyContent: 'space-evenly' }} >
        <Button shape="circle" icon={<FormOutlined />} onClick={() => showEvent(o.id)} />
        <ActionButton shape="circle" icon={o.resolved ? <CloseOutlined /> : <CheckOutlined />} onClick={() => resolveEvent(o)} />
      </div>)
    }
  ]

  const rowClassName = (record) => {
    return record.new ? 'new-event' : ''
  }

  return (
    <CustTable
      style={{ height: 'calc(100vh - 290px)' }}
      height={700}
      initColumns={columns(showEvent, resolveEvent)}
      key={'number'}
      className={'events'}
      rowClassName={rowClassName}
      dataSource={events}
      pagination={{ size: 'large', placement: ['topStart'], defaultPageSize: 12, styles: { item: { borderRadius: '9px', border: 'solid black 1px' } } }}
    />
  )
}
